// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import commonEN from './common/en';
import commonTR from './common/tr';

const resources = {
    en: {
        common: commonEN,
    },
    tr: {
        common: commonTR,
    },
};

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        defaultNS: 'common',
        fallbackLng: 'tr',
        supportedLngs: ['tr', 'en'],
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
